'use client';
import React, { useEffect, useState } from 'react';
import { FavHeart } from '../../icons';
import { validatePrice } from '@/utils/category';
import Image from '@/components/image';
import { handlePriceByComma } from '@/helpers/common';
import CurrencyIcon from '../icons/currency-icon';

const WishlistCard = ({ product, handleFav }) => {
  const [img, setImg] = useState(product?._media_?.image?.at(0)?.image);
  useEffect(
    () => setImg(product?._media_?.image?.at(0)?.image),
    [product?._media_?.image]
  );

  const prices = validatePrice(product?.prices_with_tax);
  const productName = Array.isArray(product?.name)
    ? product?.name?.[0]
    : product?.name;

  return (
    <div className='border-border w-full overflow-hidden rounded-lg border'>
      <div className='relative w-full'>
        <div
          className='relative cursor-pointer rounded-lg bg-white'
          onMouseEnter={() =>
            setImg(
              product?._media_?.image?.at(1)?.image ||
                product?._media_?.image?.at(0)?.image
            )
          }
          onMouseLeave={() => setImg(product?._media_?.image?.at(0)?.image)}
        >
          <Image
            src={img}
            alt={productName}
            className='h-48 w-full object-contain max-md:h-32'
          />
        </div>
        {prices?.specialPrice > 0 && (
          <span className='bg-primary absolute top-2 left-2 rounded px-3 py-1 text-xs font-semibold text-white'>
            -{' '}
            {handlePriceByComma(
              (+prices.specialPrice / +prices.originalPrice) * 100
            )}
            %
          </span>
        )}
        <button
          onClick={() => handleFav && handleFav(product)}
          className='bg-primary absolute top-2 right-2 flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg focus:outline-none'
        >
          <FavHeart />
        </button>
      </div>
      <div className='p-3'>
        <p className='text-xs text-gray-500'>{'Brand Name'}</p>
        <h3 className='line-clamp-2 min-h-12'>{productName}</h3>
        <p className=''>{product?.model}</p>
        <div className='mt-2 flex items-center justify-between'>
          <span className='flex items-center gap-1 font-semibold'>
            {prices.originalPrice} <CurrencyIcon className='size-3' />
          </span>
          {+prices.originalPrice != +prices.specialPrice && (
            <span className='flex items-center gap-1 text-sm text-gray-400 line-through'>
              {+prices.originalPrice - +prices.specialPrice}{' '}
              <CurrencyIcon className='size-3' />
            </span>
          )}
        </div>
        <div className='bg-primary mt-2 flex items-center justify-between rounded-lg px-2 py-1 text-xs text-white'>
          <span className='flex items-center gap-1'>
            SAVE {+prices.originalPrice - +prices.specialPrice}{' '}
            <CurrencyIcon className='size-3' />
          </span>
          <span className=''>
            {handlePriceByComma(
              (+prices.specialPrice / +prices.originalPrice) * 100
            )}
            % OFF
          </span>
        </div>
      </div>
    </div>
  );
};

export default WishlistCard;
